
<div>
  <input
    id="message[customer_id]"
    v-model="selectedCustomerId"
    type="hidden"
    name="message[customer_id]"
  />
  <div class="clinic-message-form__customer-input-block">
    <input
      v-model="keyword"
      type="text"
      name="customer_name"
      :readonly="customerSelected"
      :placeholder="placeholder"
      class="clinic-message-form__customer-input"
      :class="{ 'clinic-message-form__customer-input--error': hasError }"
      autocomplete="off"
      @keydown.enter="searchCustomer"
      @input="checkKeywordLength"
    />
    <!-- 送信先選択済の場合は以下のボタンで飼い主の名前を表示 -->
    <button
      v-show="customerSelected"
      type="button"
      class="clinic-message-form__selected-customer-name-icon"
    >
      {{ selectedCustomerNameValue }}
    </button>
    <!-- 送信先選択済の場合は以下のリセットボタンを表示 -->
    <button
      v-show="customerSelected"
      type="button"
      class="clinic-message-form__customer-change-btn"
      @click="resetCustomer"
    >
      <i
        class="fa fa-times-circle-o clinic-message-form__customer-change-btn-icon"
        aria-hidden="true"
      ></i>
      キャンセル
    </button>
    <!-- キーワードで検索した結果を以下のテーブルで表示 -->
    <table v-show="showCustomerList" class="clinic-message-form__customer-list-table">
      <thead>
        <tr class="clinic-message-form__customer-list-table-header-row">
          <th class="clinic-message-form__customer-list-table-header">飼主名</th>
          <th class="clinic-message-form__customer-list-table-header">電話番号</th>
          <th class="clinic-message-form__customer-list-table-header">ペット名</th>
          <th class="clinic-message-form__customer-list-table-header">診察券番号</th>
          <th class="clinic-message-form__customer-list-table-header">種別</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="customer in searchedCustomers"
          :key="customer.value"
          class="clinic-message-form__customer-list-tbody-tr"
          @click="selectCustomer(customer)"
        >
          <td class="clinic-message-form__customer-list-tbody-td">{{ customer.name }}</td>
          <td class="clinic-message-form__customer-list-tbody-td">{{ customer.tel }}</td>
          <td class="clinic-message-form__customer-list-tbody-td">
            <div
              v-for="customer_pet in customer.customer_pets"
              :key="customer_pet.value"
              class="clinic-message-form__customer-list-tbody-pet-info-name"
            >
              <span>{{ customer_pet.name }}</span>
              <img v-if="customer_pet.dead" :src="heavenImg" height="19" />
            </div>
          </td>
          <td class="clinic-message-form__customer-list-tbody-td">
            <span
              v-for="customer_pet in customer.customer_pets"
              :key="customer_pet.value"
              class="clinic-message-form__customer-list-tbody-pet-info"
              >{{ customer_pet.patient_card_number }}</span
            >
          </td>
          <td class="clinic-message-form__customer-list-tbody-td">
            <span
              v-for="customer_pet in customer.customer_pets"
              :key="customer_pet.value"
              class="clinic-message-form__customer-list-tbody-pet-info"
              >{{ customer_pet.klass }}</span
            >
          </td>
        </tr>
        <tr v-if="searchedCustomers.length == 0">
          <td class="clinic-message-form__customer-list-tbody-td" colspan="5">該当なし</td>
        </tr>
      </tbody>
    </table>
  </div>
  <button
    type="button"
    :disabled="customerSelected"
    class="clinic-message-form__customer-search-btn"
    @click="searchCustomer"
  >
    検索
  </button>
</div>
